import React from 'react'
import { NOTIFICATION_MODAL } from '../constants'
import { WelcomeTourModal } from './welcome-tour-modal'
import { WhatsNewModal } from './whats-new-modal'
import { OrgRecommendsModal } from './org-recommends-modal'

/** Renders whichever notification modal is active (or none). */
export const NotificationModals = ({ activeModal, onClose }) => (
  <>
    <WelcomeTourModal open={activeModal === NOTIFICATION_MODAL.WELCOME_TOUR} onClose={onClose} />
    <WhatsNewModal open={activeModal === NOTIFICATION_MODAL.WHATS_NEW} onClose={onClose} />
    <OrgRecommendsModal open={activeModal === NOTIFICATION_MODAL.ORG_RECOMMENDS} onClose={onClose} />
  </>
)

export default NotificationModals
export { WelcomeTourModal } from './welcome-tour-modal'
export { WhatsNewModal } from './whats-new-modal'
export { OrgRecommendsModal } from './org-recommends-modal'
export { BaseNotificationModal } from './base-modal'
